import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Token {
  private _token = signal<string | null>(localStorage.getItem('auth_token'));

  getToken() {
    return this._token();
  }

  setToken(token: string) {
    this._token.set(token);
    localStorage.setItem('auth_token', token);
  }

  clearToken() {
    this._token.set(null);
    localStorage.removeItem('auth_token');
  }
}
